import React from 'react';
import { Card, CardContent } from '@mui/material';
import dayjs from 'dayjs';

const MarketCard = ({ card, onCardClick }) => {
  
  const removeNumbersAndAfter = (tradingSymbol) => {
    const s = tradingSymbol || '';
    const index = s.search(/\d/);
    return index !== -1 ? s.substring(0, index) : s;
  };

   const extractDateFromSymbol = (tradingSymbol) => {
    const match = (tradingSymbol || '').match(/\d{1,2}[A-Z]{3}\d{2}/);
    return match ? match[0] : null;
  };

  const abbreviateNumber = (number) => {
    if (number >= 1e9) {
      return (number / 1e9).toFixed(1) + 'B';
    }
    if (number >= 1e6) {
      return (number / 1e6).toFixed(1) + 'M';
    }
    if (number >= 1e3) {
      return (number / 1e3).toFixed(1) + 'K';
    }
    return number.toString();
  };

  const extractedDate = extractDateFromSymbol(card.tradingSymbol);
  const formattedDate = extractedDate
    ? dayjs(extractedDate).format('YYYY-MM-DD')
    : '';
  
  return (
    <Card
      className="px-0 py-0 mt-1 mb-2 h-[50px] bg-white cursor-pointer"
      onClick={() => onCardClick(card, formattedDate)}
    >
      <CardContent>
        <div className="flex justify-between items-center w-full -mt-[10px]">
          {/* Name and Date Section */}
          <div className="flex flex-col items-start w-3/4">
            <span className="font-semibold text-[14px]">
              {removeNumbersAndAfter(card.tradingSymbol)}
            </span>
            <span className="text-[12px] text-gray-500">{formattedDate}</span>
          </div>

          {/* Value and Volume Section */}
          <div className="flex flex-col items-center w-3/4">
            <span className="font-semibold text-[14px]">{Number(card.avgPrice ?? card.ltp ?? 0).toFixed(2)}</span>
            <span className="text-[12px] text-gray-500">
              Vol: {abbreviateNumber(Number(card.tradeVolume ?? 0))}
            </span>
          </div>

          {/* Change and Percentage Section */}
          <div className="flex flex-col items-end w-3/4">
            <span
              className={`font-semibold text-[14px] ${parseFloat(card.netChange) > 0 ? "text-[#089981]" : "text-[#F23645]"
                }`}
            >
              {card.netChange !== undefined
                ? `${parseFloat(card.netChange) > 0 ? "+" : ""}${parseFloat(card.netChange).toFixed(2)}`
                : "--"}
            </span>
            <span
              className={`text-[12px] ${parseFloat(card.percentChange) > 0 ? "text-[#089981]" : "text-[#F23645]"
                }`}
            >
              {card.percentChange !== undefined
                ? `${parseFloat(card.percentChange) > 0 ? "+" : ""}${parseFloat(card.percentChange).toFixed(2)}%`
                : "--"}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

// Only re-render a card when its own data object actually changed (the tick
// consumer keeps the same reference for untouched rows), so a tick for one
// script doesn't repaint the whole list — keeps the Market list smooth.
export default React.memo(MarketCard, (prev, next) => prev.card === next.card);